import { PopularItemType, PopularListType } from "@/types/locations/popular";
import { PopularInterface } from "@/interface/locations/popular";

export default class Popular implements PopularInterface {
  public list: Array<PopularListType> = [];
  public items: Array<PopularItemType> = [];

  constructor(data) {
    this.list = data;
    this.setItems();
  }

  /**
   * Set Items
   * @return {void}
   */
  public setItems() {
    this.list.forEach((pList) => {
      pList.items.forEach((item) => {
        //unique item in list
        if (this.items.findIndex((i) => i.id === item.id) < 0) {
          this.items.push(item);
        }
      });
    });
  }
}
